// extracted by mini-css-extract-plugin
export default {"wrapper":"RegrasDePrecoFooter_wrapper__rd8kK","link-button":"RegrasDePrecoFooter_link-button__FTPCC"};